/**
 * Subtype of an entitlement specified in EntitlementType(1775).
 * tag: 2402
 * @readonly
 * @enum {number} (int)
 */
export enum EntitlementSubType {
  OrderEntry = 1,
  HItLift = 2,
  ViewIndicativePx = 3,
  ViewExecutablePx = 4,
  SingleQuote = 5,
  StreamingQuotes = 6,
  SingleBroker = 7,
  MultiBrokers = 8,
}
